import { render } from "./TheNotificationBottomArea.vue?vue&type=template&id=585b39b2&scoped=true&ts=true"
import script from "./TheNotificationBottomArea.vue?vue&type=script&lang=ts"
export * from "./TheNotificationBottomArea.vue?vue&type=script&lang=ts"

import "./TheNotificationBottomArea.vue?vue&type=style&index=0&id=585b39b2&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src602189598/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-585b39b2"]])

export default __exports__